import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TConfigurationFormModelTypes } from '../../../../models/form-builder-types-configurations.model';
import {
  getDefaultBaseSettingsConfigFormly,
  getPopulatesPropsSettingsConfigFormly,
} from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  getCrvsFieldSettingsConfig,
  crvsResponseProps,
  crvsFieldParseIntoSettingsFormModel,
  crvsFieldUpdateFromSettingsFormModel,
} from '../crvs-id-input.configuration';
import { fieldsBaseConfigurationFormModel } from '../shared.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class CustomCRVSIdInputFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    this.settingsFormlyModel = {
      ...fieldsBaseConfigurationFormModel(),
      crvsFieldContentConfig: {
        documentTypeKey: 'DocumentTypeComponentKey',
        useBaseUrl: true,
        endpointCode: 'IGV3_FETCH_RECORD_TEST',
        allowedDocumentTypes: [],
      },
    };
    this.settingsFormlyForm = [
      ...getCrvsFieldSettingsConfig(this.formBuilderService),
      ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
      ...getPopulatesPropsSettingsConfigFormly(this.formBuilderService, [
        ...Array.from(crvsResponseProps),
      ]),
    ];
    this.availableValidations.push('invalidInput', 'invalidId');
  }

  override parseFieldConfigIntoSettingsFormModel(): TConfigurationFormModelTypes {
    return crvsFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(model: any) {
    return crvsFieldUpdateFromSettingsFormModel(model, this.field);
  }
}
